import { AppLayout } from '@/layouts/AppLayout';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <AppLayout breadcrumbs={[]}>
      <main className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-4xl font-bold">{t('notFound.title')}</h1>
        <p className="text-lg">{t('notFound.description')}</p>
        <Link to="/" className="text-blue-500">{t('notFound.goBackToHome')}</Link>
      </main>
    </AppLayout>
  );
};
